import { TermsOfUse, getStaticProps } from 'routes/public/TermsOfUse'

export { getStaticProps }

export default TermsOfUse
